// Async Thunk for fetching banners
import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
const BASE_URL = process.env.REACT_APP_BASE_URL;

export const fetchBanners = createAsyncThunk(
  "banners/fetchBanners",
  async (lang, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/banners`, {
        headers: {
          'Accept-Language': lang || 'en',
          'Accept': 'application/json'
        }
      });
     
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || "Failed to fetch banners";
      return rejectWithValue({ message });
    }
  }
);